import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "content mt-16 mb-4 px-4" }
const _hoisted_2 = { class: "font-bold text-xl mb-8" }
const _hoisted_3 = {
  key: 0,
  class: "grid grid-cols-12 gap-8 ml-min mb-4"
}
const _hoisted_4 = { class: "col-span-1" }
const _hoisted_5 = { class: "icon-number float-right" }
const _hoisted_6 = { class: "icon_item mb-12px" }
const _hoisted_7 = { class: "icon_circle" }
const _hoisted_8 = { class: "icon_number" }
const _hoisted_9 = { class: "col-span-3" }
const _hoisted_10 = { for: "fullName" }
const _hoisted_11 = { class: "col-span-2" }
const _hoisted_12 = { for: "phoneNumber" }
const _hoisted_13 = { class: "col-span-2" }
const _hoisted_14 = { for: "relationship" }
const _hoisted_15 = { class: "col-span-3" }
const _hoisted_16 = { for: "address" }
const _hoisted_17 = { class: "col-span-1" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "col-span-1" }
const _hoisted_20 = { class: "icon-number float-right" }
const _hoisted_21 = { class: "icon_item" }
const _hoisted_22 = { class: "icon_circle" }
const _hoisted_23 = { class: "icon_number" }
const _hoisted_24 = { class: "col-span-3" }
const _hoisted_25 = { class: "mb-4" }
const _hoisted_26 = { class: "invalid-feedback" }
const _hoisted_27 = { class: "col-span-2" }
const _hoisted_28 = { class: "mb-4" }
const _hoisted_29 = { class: "invalid-feedback" }
const _hoisted_30 = { class: "col-span-2" }
const _hoisted_31 = { class: "mb-4" }
const _hoisted_32 = { class: "card flex justify-content-center" }
const _hoisted_33 = { class: "invalid-feedback" }
const _hoisted_34 = { class: "col-span-3" }
const _hoisted_35 = { class: "mb-4" }
const _hoisted_36 = { class: "invalid-feedback" }
const _hoisted_37 = {
  key: 0,
  class: "col-span-1"
}
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "flex mt-auto float-right pt-16" }

import Button from 'primevue/button'
import Dropdown from 'primevue/dropdown'
import InputText from 'primevue/inputtext'
import * as Yup from 'yup'
import { Form, Field } from 'vee-validate'
import { computed, getCurrentInstance, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import apiUseCase from '@/usecase/apiUseCase'
import rgxExp from '@/utils/helpers/regExp'
import { useRoute, useRouter } from 'vue-router'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import ContactRelationshipOptions from '../../dataOptions/ContactRelationshipOptions'
import ContactRelationshipDefiner from '../../dataOptions/helpers/ContactRelationshipHelper'

const moduleStore = 'hjpTable'
const employeeEndpoint = 'talent/v1/employees'
const emergencyContactsBulkEndpoint = 'emergencyContacts/Bulk'
const emergencyContactsEndpoint = 'emergencyContacts'

export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeEmergencyContact',
  setup(__props) {

const store = useStore()
const route = useRoute()
const router = useRouter()
const idPrams = ref(null) as any
const isLoading = ref(true)
const employeeId = ref()
const exDataCount = ref(0)
const newData = ref(0)
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const toast = (status: any, message: any) => {
  $toast.add({
    severity: status,
    detail: message,
    group: 'bc',
    closable: false,
    life: 3000
  })
}

// const initialValues = {
//   Id: null as any,
//   Fullname: null as any,
//   Relationship: null as any,
//   PhoneNumber: null as any,
//   Address: null as any,
// }
const relationshipOptions = ref(ContactRelationshipOptions())
// const relationshipOptions = ref([
//   'Child', 'Parent', 'Partner'
// ])

// const schema = Yup.object().shape({
//   FullnameEmergencyContact: Yup.string()
//     .required('Nama Lengkap tidak boleh kosong')
//     .max(100, 'Nama Lengkap tidak boleh melebihi 100 karakter'),
//   PhoneNumberEmergencyContact: Yup.string()
//     .required('Nomor Telepon tidak boleh kosong')
//     .min(11, 'Nomor Telepon minimal 11 karakter')
//     .max(14, 'Nomor Telepon maksimal 14 karakter')
//     .matches(rgxExp.phoneNumber, 'Masukkan Nomor Telepon valid dan harus diawali angka 0.'),
//   RelationshipEmergencyContact: Yup.object()
//     .required('Status Pernikahan tidak boleh kosong'),
//   AddressEmergencyContact: Yup.string()
//     .required('Alamat Kontak Darurat tidak boleh kosong')
//     .max(400, 'Alamat Kontak Darurat tidak boleh melebihi 400 karakter'),
// })

const schema = Yup.lazy((FullnameEmergencyContact) => {
  const shapes: any = {}
  const DATA_OBJ_KEYS = Object.keys(FullnameEmergencyContact)

  DATA_OBJ_KEYS.forEach(((parameter) => {
    shapes[parameter] = Yup.string().required('Wajib diisi')
  }))

  return Yup.object().shape(shapes)
})

const dataForm = ref([]) as any

const dataExist = ref([]) as any

const dataFormPost = ref([]) as any

const addField = () => {
  newData.value++
  dataForm.value.push({ employeeId: idPrams.value?.id ?? employeeId.value, fullName: '', relationship: '', phoneNumber: '', remarks: '' })
  // dataFormPost.value.push({ id: idPrams.value.id, fullName: '', relationship: '', phoneNumber: '', remarks: '' })
  // dataForm.value.push({ id: `${dataForm.value.length + 1}`, fullName: '', contactRelationship: '', phoneNumber: '' })
}

const deleteContactById = async (index: number, item: any) => {
  store.dispatch('showLoading')
  const response = await apiUseCase.delete(`${employeeEndpoint}/${idPrams.value?.id ?? employeeId.value}/${emergencyContactsEndpoint}`, item)
  console.log('response', response)
  if (!response.error) {
    dataExist.value.splice(index, 1)
    exDataCount.value--
    toast('success', 'Berhasil menghapus Data Kontak Darurat')
    if (!idPrams.value) store.dispatch('employee/setEmployeeFormStep', 4)
  } else {
    toast('error', 'Gagal menghapus Data Kontak Darurat')
  }
  store.dispatch('hideLoading')
}

const removeExist = (index: number) => {
  dataExist.value.splice(index, 1)
}

const removeField = (index: number, id: any) => {
  // if (index >= exDataCount.value) {
    dataForm.value.splice(index, 1)
    // dataFormPost.value.splice(index, 1)
    newData.value--
  // } else {
    // deleteContactById(index, id)
  // }
}

const onBack = () => {
  // console.log('back')
  router.push({
    // path: baseRoute.value
    name: 'master-employee'
  })
}

const clearExistingData = async () => {
  let i = 0
  while (i < exDataCount.value) {
    dataForm.value.splice(i, 1)
    i++
  }
}

const prepareNewData = async () => {
  let i = 0
  console.log('newData', newData.value)
  console.log('dataForm.value.length', dataForm.value.length)
  console.log('dataForm.value', dataForm.value)
  console.log('dataForm.value', dataForm[0])
  while (i < newData.value) {
    dataFormPost.value.push(dataForm.value[dataForm.value.length - (i + 1)])
    i++
  }
}

const processSubmit = async () => {
  store.dispatch('showLoading')
  // prepareNewData()
  console.log('dataFORMPOST', dataForm)
  if (dataForm.value.length === 0) {
    toast('success', 'Data Karyawan Berhasil Disimpan')
    onBack()
    store.dispatch('hideLoading')
    return
  }
  const response = await apiUseCase.postOrPut(`${employeeEndpoint}/${idPrams.value.id ?? employeeId.value}/${emergencyContactsBulkEndpoint}`, null, dataForm.value)
  console.log('response', response)
  if (!response.error) {
    toast('success', 'Berhasil menyimpan Data Kontak Darurat')
    if (!idPrams.value) store.dispatch('employee/setEmployeeFormStep', 4)
    dataForm.value = []
    // eslint-disable-next-line no-use-before-define
    getData()
  } else {
    toast('error', 'Gagal menyimpan Data Kontak Darurat')
  }
  store.dispatch('hideLoading')
}

const onSubmit = (values: any) => {
  console.log('submit', values)
  processSubmit()
}

const checkEmployeeId = async () => {
  try {
    console.log('employeeid from prev', idPrams.value)
    if (!idPrams.value) idPrams.value = store.getters['employee/getEmployeeId']
    console.log('employeeid after load', idPrams.value)
  } catch (e) {
    console.log(e)
  }
}

const getData = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${employeeEndpoint}/${idPrams.value?.id ?? employeeId.value}/${emergencyContactsEndpoint}`).then((response) => {
    const { error, result } = response
    if (!response.error) {
      console.log('resullttt', result)
      // dataForm.value = result
      dataExist.value = result.map((data: any) => ({
        ...data,
        relationship: ContactRelationshipDefiner(data.relationship)?.label
      }))
      console.log('dataExist', dataExist)
      // console.log('aaaaa', dataForm.value[0])
      exDataCount.value = dataExist.value.length
      // let i = 0
      // while (i < dataForm.value.length) {
      //   dataForm.value[i].disabled = true
      //   i++
      // }

      console.log('appliedd', dataForm.value)
      // dataForm.value.push(result[0])
      // dataForm.value.push(result[1])
      // dataForm.value.push(result[2])
      // dataForm.value.push(result[3])
      // result.forEach((id: number) => {
      //   dataForm.value.push(result[id])
      // })
      // dataForm.value.push(result)
      // if (!idPrams.value) store.dispatch('employee/setEmployeeFormStep', 4)
      // initialValues.Fullname = result.fullName
      // initialValues.Relationship = result.relationship
      // initialValues.PhoneNumber = result.phoneNumber
      // initialValues.Remarks = result.remarks
      // isLoading.value = false
    } else {
      // toast('error', 'Gagal menyimpan Data Kontak Darurat')
    }
  })
  store.dispatch('hideLoading')
}

onMounted(() => {
  console.log('dataForm', dataForm)
  console.log('id', store.getters['employee/getEmployeeId'])
  if (route.params.id) {
    idPrams.value = encryptDecriptMethods.decrypt(route.params.id)
    employeeId.value = idPrams.value?.id
    getData()
  } else {
    employeeId.value = store.getters['employee/getEmployeeId']
    isLoading.value = false
  }
  checkEmployeeId()
})

return (_ctx: any,_cache: any) => {
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, [
        _cache[2] || (_cache[2] = _createTextVNode("Kontak Darurat ")),
        _createElementVNode("span", {
          class: "pi pi-plus add-icon cursor cursor-pointer",
          style: {"font-size":"1rem"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (addField()))
        })
      ]),
      (dataExist.value.length > 0 || dataForm.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[3] || (_cache[3] = [
            _createStaticVNode("<div class=\"col-span-1\"></div><div class=\"col-span-3 text-sm font-bold\">Nama</div><div class=\"col-span-2 text-sm font-bold\">Nomor Telepon</div><div class=\"col-span-2 text-sm font-bold\">Status</div><div class=\"col-span-3 text-sm font-bold\">Alamat</div><div class=\"col-span-1 text-sm font-bold\"></div>", 6)
          ])))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataExist.value, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "grid grid-cols-12 gap-8 ml-min",
          key: i
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mt-1" }, null, -1)),
            _createElementVNode("ul", _hoisted_5, [
              _createElementVNode("li", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(i + 1), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, _toDisplayString(item.fullName), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", _hoisted_12, _toDisplayString(item.phoneNumber), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("label", _hoisted_14, _toDisplayString(item.relationship), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("label", _hoisted_16, _toDisplayString(item.remarks), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("i", {
              class: "pi pi-trash text-red cursor-pointer",
              style: {"font-size":"1rem"},
              onClick: ($event: any) => (deleteContactById(i, item.id))
            }, null, 8, _hoisted_18)
          ])
        ]))
      }), 128)),
      _createVNode(_unref(Form), {
        onSubmit: onSubmit,
        class: "form-container"
      }, {
        default: _withCtx(({ errors, meta }) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataForm.value, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "grid grid-cols-12 gap-8 ml-min",
              key: i
            }, [
              _createElementVNode("div", _hoisted_19, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mt-1" }, null, -1)),
                _createElementVNode("ul", _hoisted_20, [
                  _createElementVNode("li", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("p", _hoisted_23, _toDisplayString(exDataCount.value + i + 1), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_unref(Field), {
                    name: `FullnameEmergencyContact-${i}`
                  }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_unref(InputText), _mergeProps({ id: "fullnameEmergencyContact" }, { ref_for: true }, field.value, {
                        modelValue: item.fullName,
                        "onUpdate:modelValue": ($event: any) => ((item.fullName) = $event),
                        "aria-describedby": "fullname-help",
                        class: `input-primary ${errors.FullnameEmergencyContact ? 'input-invalid' : ''}`,
                        placeholder: "Nama kontak darurat"
                      }), null, 16, ["modelValue", "onUpdate:modelValue", "class"])
                    ]),
                    _: 2
                  }, 1032, ["name"]),
                  _createElementVNode("div", _hoisted_26, _toDisplayString(errors.FullnameEmergencyContact), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_unref(Field), {
                    name: `PhoneNumberEmergencyContact-${i}`
                  }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_unref(InputText), _mergeProps({
                        class: `input-primary ${errors.PhoneNumberEmergencyContact ? 'input-invalid' : ''}`,
                        inputId: `phoneNumber-${i}`
                      }, { ref_for: true }, field.value, {
                        modelValue: item.phoneNumber,
                        "onUpdate:modelValue": ($event: any) => ((item.phoneNumber) = $event),
                        "aria-describedby": "phone-help",
                        placeholder: "Nomor telepon kontak darurat",
                        type: "tel",
                        minlength: 10,
                        maxlength: 14
                      }), null, 16, ["class", "inputId", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["name"]),
                  _createElementVNode("div", _hoisted_29, _toDisplayString(errors.PhoneNumberEmergencyContact), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_unref(Field), {
                      id: "relationshipEmergencyContact",
                      name: `RelationshipEmergencyContact-${i}`,
                      class: _normalizeClass(`input-primary ${errors.RelationshipEmergencyContact ? 'input-invalid' : ''}`),
                      validateOnInput: true
                    }, {
                      default: _withCtx(({ }) => [
                        _createVNode(_unref(Dropdown), {
                          modelValue: item.relationship,
                          "onUpdate:modelValue": ($event: any) => ((item.relationship) = $event),
                          options: relationshipOptions.value,
                          optionLabel: "label",
                          optionValue: "value",
                          placeholder: "Pilih status hubungan",
                          class: "w-full md:w-14rem"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                      ]),
                      _: 2
                    }, 1032, ["name", "class"])
                  ]),
                  _createElementVNode("div", _hoisted_33, _toDisplayString(errors.RelationshipEmergencyContact), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_unref(Field), {
                    name: `AddressEmergencyContact-${i}`,
                    modelValue: item.remarks,
                    "onUpdate:modelValue": ($event: any) => ((item.remarks) = $event)
                  }, {
                    default: _withCtx(({ handleChange, handleBlur }) => [
                      _createVNode(_component_Textarea, {
                        maxlength: 400,
                        id: "address",
                        "aria-describedby": "address-help",
                        modelValue: item.remarks,
                        "onUpdate:modelValue": ($event: any) => ((item.remarks) = $event),
                        autoResize: true,
                        rows: "3",
                        onChange: handleChange,
                        onBlur: handleBlur
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "onBlur"])
                    ]),
                    _: 2
                  }, 1032, ["name", "modelValue", "onUpdate:modelValue"]),
                  _createElementVNode("div", _hoisted_36, _toDisplayString(errors.AddressEmergencyContact), 1)
                ])
              ]),
              (dataForm.value.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("i", {
                      class: "pi pi-times text-red cursor-pointer",
                      style: {"font-size":"1rem"},
                      onClick: ($event: any) => (removeField(i, item.id))
                    }, null, 8, _hoisted_38),
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mt-6" }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_unref(Button), {
              class: "btn-back mr-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (onBack()))
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("Kembali")
              ])),
              _: 1,
              __: [7]
            }),
            _createVNode(_unref(Button), {
              type: "submit",
              class: "btn-primary mr-1",
              disabled: (meta.valid && false)
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("Simpan Karyawan")
              ])),
              _: 2,
              __: [8]
            }, 1032, ["disabled"])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})